var indentation_default = {
  "indentZero": "H1g7S",
  "indentOne": "_73eCQ",
  "indentTwo": "W6uET",
  "indentThree": "_0ZbDb",
  "indentFour": "R0-Cg",
  "indentFive": "BTCtb",
  "indentSix": "_5FN1O"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
